import { createEndpoint } from '@/shared/models/api';
import { ConverterRequest } from '@/app/api/morgan-thermal/converter';

export const convertDistance = createEndpoint<number>(({fetch}) => ({ isMetric, value }: ConverterRequest) => fetch(`/Converter/Distance/${isMetric}/${value}`));